// extracted by mini-css-extract-plugin
export var station_mobile_tab_view = "station-mobile-tab-view-module--station_mobile_tab_view--2huzW";
export var station_mobile_tab_view__tabs = "station-mobile-tab-view-module--station_mobile_tab_view__tabs--ywjQh";
export var station_mobile_tab_view__margin = "station-mobile-tab-view-module--station_mobile_tab_view__margin--guNZL";